export default {
    coffeeData: {
        coffeeSpecies: "Spesies Kopi",
        coffeeCherryQuality: "Kualitas Biji Kopi Cherry",
        processingBatchQuality: "Kualitas Batch Pengolahan",
        greenCoffeeQuality: "Kualitas Kopi Hijau",
        processType: "Jenis Proses",
    },
    memberDataSection: {
        import: "Impor",
        buyingStation: "Stasiun Pembelian",
        factory: "Pabrik",
        factories: "Pabrik",
        factoriesName: "Nama Pabrik",
        factoriesProdChart: "Grafik Produksi Pabrik",
        factoryInfo: "Informasi Pabrik",
        continue: "Lanjutkan",
        farmerId: "ID Petani",
        farmerName: "Nama Petani",
        farmerAddress: "Alamat Petani",
        quality: "Kualitas",
        quantity: "Kuantitas",
        importAll: "Impor Semua",
        importSelected: "Impor yang Dipilih",
        fileLoaded: "Berkas berhasil dimuat",
        incorrectHeaders: "Header salah",
        processingBatch: "Memproses Batch",
        purchaseOrder: "Pesanan Pembelian",
        startDate: "Tanggal Mulai",
        endDate: "Tanggal Akhir",
        purchasingOrder: "Pesanan Pembelian",
        totalCoffeeCherry: "Total Biji Kopi Cherry",
        airHumidity: "Kelembapan Udara",
        density: "Kepadatan",
        temperature: "Suhu",
        beanMoistureContent: "Kandungan Air Biji Kopi",
        processType: "Jenis Proses",
        batchRating: "Pilih Rating Batch",
        purchaseDate: "Tanggal Pembelian",
        selectFarmer: "Pilih Petani",
        selectFarm: "Pilih Perkebunan",
        selectPlantation: "Pilih Perkebunan",
        coffeeVariety: "Varietas Kopi",
        coffeeSpecies: "Spesies Kopi",
        coffeeCherryQuantity: "Kuantitas Biji Kopi Cherry",
        coffeeCherryQuality: "Kualitas Biji Kopi Cherry",
        coffeeType: "Tipe Kopi",
        pricePerKg: "Harga Per Kg",
        processingDone: "Pengolahan Selesai",
        processedCoffeeOut: "Kopi yang Diproses Keluar",
        farmer: "Petani",
        farm: "Perkebunan",
        plantation: "Perkebunan",
        farmers: "Petani",
        selectCrop: "Pilih Tanaman",
        farmLimitUsed: "Batas Penggunaan Perkebunan",
        phoneNumber: "Nomor Telepon",
        farmSize: "Ukuran Perkebunan",
        farmLocation: "Lokasi Perkebunan",
        date: "Tanggal",
        status: "Status",
        noFarmers: "Tidak Ada Petani Ditemukan",
        approveReject: "Terima / Tolak",
        farms: "Perkebunan",
        crops: "Tanaman",
        equipment: "Peralatan",
        noFarms: "Tidak Ada Perkebunan Ditemukan",
        views: "Lihat",
        selectStatus: "Pilih Status",
        approved: "Disetujui",
        rejected: "Ditolak",
        reject: "Tolak",
        approve: "Setujui",
        conclude:"Selesaikan",
        cancel: "Batal",
        add: "Tambah",
        describeYourReason: "Deskripsikan alasan Anda di sini",
        userInformation: "Informasi Pengguna",
        userFarmRequest: "Permintaan Perkebunan Pengguna",
        userFarmInformation: "Informasi Perkebunan Pengguna",
        activity: "Aktivitas",
        activityType: "Tipe Aktivitas",
        farmZone: "Zona Perkebunan",
        farmerView: "Tampilan Petani",
        cropType: "Tipe Tanaman",
        cropVarity: "Varietas Tanaman",
        area: "Luas",
        cost: "Biaya",
        geofence: "Geofence",
        map_views: "Tampilan Peta",
        viewAllFarms: "Lihat Semua Perkebunan",
        farmersDetails: "Detail Petani",
        download: "Unduh",
        pOrder: {
          addNew: "Tambah Baru",
          viewAll: "Lihat Semua",
          selectDate: "Pilih tanggal",
          makeSelection: "Pilih salah satu",
          coffeeType: "Tipe kopi kuantitas",
          enterPrice: "Masukkan Harga",
          reqPurchaseDate: "Tanggal pembelian diperlukan",
          reqFarmer: "Petani diperlukan",
          reqCoffeeQnty: "Kuantitas Biji Kopi Cherry diperlukan",
          reqPrice: "Harga Per Kg diperlukan",
          grandTotal: "TOTAL BESAR",
          selectDateRange: "Pilih Rentang Tanggal",
          import: "Impor",
          purchaseId: "ID Pembelian",
          purchaseDate: "Tanggal Pembelian",
          farmerName: "Nama Petani",
          quality: "Kualitas",
          quantity: "Kuantitas",
          pricePerKg: "Harga Per Kg",
          selectBuyingStation: "Pilih stasiun pembelian",
          searchUser: "Cari Pengguna",
        },
        farmActivity: "Aktivitas Perkebunan",
        showOnMap: "Tampilkan di Peta",
        farmInformation: "Informasi Perkebunan",
        dateOfEntry: "Tanggal Masuk",
        farmID: "ID Perkebunan",
        ownershipType: "Tipe Kepemilikan",
        locationAddress: "Alamat Lokasi",
        goalType: "Tipe Tujuan",
        totalSize: "Ukuran Total",
        zones: "Zona",
        farmActivities: "Aktivitas Perkebunan",
        farmDetails: "Detail Perkebunan",
        totalFarmsRegistered: "Total Perkebunan Terdaftar",
        totalFarmArea: "Total Luas Perkebunan",
        totalZone: "Total Zona",
        zone: "Zona",
        totalCost: "Total Biaya",
        selectFarmZone: "Pilih Zona / Perkebunan",
        productionType: "Tipe Produksi",
        certifications: "Sertifikasi",
        geofences: "Geofences",
        farmsChart: "Grafik Perkebunan",
        
        
    // Buying Station specific translations
    buyingStations: "Stasiun Pembelian",
    registerBuyingStation: "Daftarkan Stasiun Pembelian",
    registerFactory: "Daftarkan Pabrik",
    loadingFactory: "Memuat Pabrik...",
    loadingBuyingStation: "Memuat Stasiun Pembelian...",
    searchBuyingStation: "Cari Stasiun Pembelian",
    searchFactory: "Cari Pabrik",
    nameAndId: "Nama / ID",
    email: "Email",
    mobileNumber: "Nomor Ponsel",
    role: "Peran",
    actions: "Aksi",
    view: "Lihat",
    edit: "Edit",
    activate: "Aktifkan",
    deactivate: "Nonaktifkan",
    operator: "Operator",
    supplier: "Pemasok",
    active: "Aktif",
    deactivated: "Dinonaktifkan",
    activatedSuccessfully: "Stasiun pembelian berhasil diaktifkan",
    deactivatedSuccessfully: "Stasiun pembelian berhasil dinonaktifkan",
  
    factoryActivatedSuccessfully: "Pabrik berhasil diaktifkan",
    factoryDeactivatedSuccessfully: "Pabrik berhasil dinonaktifkan",
    factoryRegisteredSuccessfully: "Pabrik berhasil didaftarkan",
    
    // Buying Station Details specific translations
    userDetails: "Detail Pengguna",
    name: "Nama",
    provinceState: "Provinsi/Negara Bagian",
    villageCityTown: "Desa/Kota/Kecamatan",
    country: "Negara",
    associatedFarms: "Perkebunan Terkait",
    back: "Kembali",
    addPurchaseOrder: "Tambah Pesanan Pembelian",
    search: "Cari",
    orderId: "ID Pesanan",
    farmFarmer: "Perkebunan / Petani",
    coffeeSpeciesVariety: "Spesies / Varietas Kopi",
    quantityPrice: "Kuantitas / Harga",
    delete: "Hapus",
    
    // Processing Batch specific translations
    addProcessingBatch: "Tambah Batch Pengolahan",
    batchId: "ID Batch",
    lots: "Lot",
    greenCoffeeOut: "Kopi Hijau Keluar",
    startEndDate: "Tanggal Mulai / Tanggal Akhir",
    
    // Associated Farms specific translations
    addFarm: "Tambah Perkebunan",
    farmNameAndId: "Nama & ID Perkebunan",
    addressOfProduction: "Alamat Produksi",
    areaHa: "Luas (ha)",
    type: "Tipe",
    eudrDeforestationStatus: "Status Deforestasi EUDR",
    eudrDeforestationStatusTT: "Status Penilaian Risiko Deforestasi EUDR",
    zeroNegligibleProbability: "Probabilitas Nol/Diabaikan",
    assessments: "Penilaian",
    riskAssessment: "Penilaian Risiko",
    compliant: "Sesuai",
    nonCompliant: "Tidak Sesuai",
    pending: "Tertunda",
    dateOfSubmission: "Tanggal Pengajuan",
    dateOfExpiry: "Tanggal Kedaluwarsa",
    
    confirmDialog: {
      delete: {
        title: "Hapus Stasiun Pembelian",
        message: "Apakah Anda yakin ingin menghapus stasiun pembelian ini?",
        confirmBtn: "Hapus",
      },
      activate: {
        title: "Aktifkan",
        message: "Apakah Anda yakin ingin mengaktifkan {entity} ini?",
        confirmBtn: "Aktifkan",
      },
      deactivate: {
        title: "Nonaktifkan",
        message: "Apakah Anda yakin ingin menonaktifkan {entity} ini?",
        confirmBtn: "Nonaktifkan",
      },
    },
    
    registerNewFactory: "Daftarkan Pabrik Baru",
    selectHowYouWantToProceed: "Pilih cara Anda ingin melanjutkan",
    single: "Tunggal",
    multiple: "Ganda",
    user: "Pengguna",
    createNewFactory: "Buat Pabrik Baru",
    factoryName: "Nama Pabrik",
    factoryNumber: "Nomor Pabrik",
    firstName: "Nama Depan",
    lastName: "Nama Belakang",
    primaryEmailAddress: "Alamat Email Utama",
    submit: "Kirim",
    downloadTemplate: "Unduh Template",
    templateInfo: "Unduh file template untuk melihat format yang diperlukan untuk pendaftaran massal.",
    templateFormat: "Mohon berikan file dalam format CSV.",
    selectFileToUpload: "Pilih file untuk mengunggah data",
    uploadFileOrDragAndDrop: "atau seret dan letakkan di sini",
  },
}